import React from "react";

import Tooltip from "@material-ui/core/Tooltip";

import BlockIcon from '@material-ui/icons/Block';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import OfflineBoltOutlinedIcon from '@material-ui/icons/OfflineBoltOutlined';

import Chip from "@material-ui/core/Chip";
import "./style.css";

const lookup = [
  {
    value: 0,
    text: "НАБОР ЗАКРЫТ"
  },
  {
    value: 1,
    text: "ВЕДЁТСЯ НАБОР"
  }
];

function planStateExcelCell(options, column, gridCell) {
  if (gridCell.value === 0) {
    options.value = "НАБОР ЗАКРЫТ";
  } else if (gridCell.value === 1) {
    options.value = "ВЕДЁТСЯ НАБОР";
  } else {
    options.value = "БЕЗ СТАТУСА";
  }
}

function planStateCell(config) {
  config.cellRender = PlanStateCell;
  config.dataType = "number";
  config.alignment = "center";
  config.lookup = {
    dataSource: lookup,
    valueExpr: "value",
    displayExpr: "text"
  }
}

const planSateTextColor = {
  '0': "#CACCD1",
  '1': "#85C446"
};

const PlanStateCell = (cellData) => {
  const stateId = cellData.value;

  switch (stateId) {
    case 0:
      return (
        <div>
          <Tooltip title="НАБОР ЗАКРЫТ">
            <Chip color="primary"
                  style={{ "background": planSateTextColor[stateId]}}
                  size="small"
                  classes={{
                    label: 'labelChip',
                    icon: 'iconChip'
                  }}
                  icon={<BlockIcon fontSize={"small"}/>}/>
          </Tooltip>
        </div>
      );
    case 1:
      return (
        <div>
          <Tooltip title="ВЕДЁТСЯ НАБОР">
            <Chip color="primary"
                  style={{ "background": planSateTextColor[stateId]}}
                  size="small"
                  classes={{
                    label: 'labelChip',
                    icon: 'iconChip'
                  }}
                  icon={<OfflineBoltOutlinedIcon fontSize={"small"}/>}/>
          </Tooltip>
        </div>
      );
    default:
      return (
        <div>
          <Tooltip title="БЕЗ СТАТУСА">
            <Chip color="primary"
                  style={{ "background": "black"}}
                  size="small"
                  classes={{
                    label: 'labelChip',
                    icon: 'iconChip'
                  }}
                  icon={<HelpOutlineIcon fontSize={"small"}/>}
            />
          </Tooltip>
        </div>
      );
  }
};


export {planStateCell, planStateExcelCell}
